import React, { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Box,
  TextField, Typography, IconButton, Grid, Chip
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

/**
 * Escolhe o que gravar na ficha do cliente.
 *
 * O nome do campo e livre porque cada negocio chama as coisas do seu jeito.
 * O valor aceita variaveis do fluxo, entao o mesmo bloco serve para dado de
 * gateway, de formulario ou do que vier antes.
 */

const SUGESTOES = [
  { nome: "Produto", valor: "{{produto}}" },
  { nome: "Plano", valor: "{{plano}}" },
  { nome: "Valor", valor: "{{valor}}" },
  { nome: "Pedido", valor: "{{pedido}}" },
  { nome: "Situação", valor: "{{status_original}}" },
  { nome: "Origem", valor: "{{tipo_evento}}" },
  { nome: "Endereço", valor: "{{endereco}}" }
];

const FlowBuilderSalvarNoContatoModal = ({ open, onSave, data, close }) => {
  const [campos, setCampos] = useState([]);

  useEffect(() => {
    if (open === "edit" && data) {
      const d = data.data || data;
      setCampos(Array.isArray(d.campos) ? d.campos : []);
    }
    if (open === "create") {
      // Comeca com o basico da recuperacao ja montado: e o uso mais comum.
      setCampos([
        { nome: "Produto", valor: "{{produto}}" },
        { nome: "Valor", valor: "{{valor}}" },
        { nome: "Pedido", valor: "{{pedido}}" }
      ]);
    }
  }, [open, data]);

  const trocar = (indice, chave, valor) => {
    setCampos(campos.map((c, i) => (i === indice ? { ...c, [chave]: valor } : c)));
  };

  return (
    <Dialog open={!!open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>Salvar no contato</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 8 }}>
          O que passa pelo fluxo some quando o atendimento acaba. O que você
          gravar aqui fica na ficha do cliente, em Informações extras, e continua
          lá depois.
        </Typography>
        <Typography variant="caption" color="textSecondary" style={{ display: "block", marginBottom: 16 }}>
          Campo com o mesmo nome é atualizado, não duplicado — o cliente pode
          voltar ao funil quantas vezes for.
        </Typography>

        {campos.map((campo, indice) => (
          <Grid container spacing={1} key={indice} alignItems="center" style={{ marginBottom: 8 }}>
            <Grid item xs={5}>
              <TextField
                fullWidth variant="outlined" size="small" label="Nome do campo"
                value={campo.nome || ""}
                onChange={(e) => { const v = e.target.value; trocar(indice, "nome", v); }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth variant="outlined" size="small" label="Valor"
                placeholder="{{produto}}"
                value={campo.valor || ""}
                onChange={(e) => { const v = e.target.value; trocar(indice, "valor", v); }}
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton size="small" onClick={() => setCampos(campos.filter((_, i) => i !== indice))}>
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            </Grid>
          </Grid>
        ))}

        <Button
          size="small"
          variant="outlined"
          onClick={() => setCampos([...campos, { nome: "", valor: "" }])}
          style={{ marginTop: 4 }}
        >
          Adicionar campo
        </Button>

        <Box style={{ marginTop: 20 }}>
          <Typography variant="caption" style={{ fontWeight: 700, display: "block", marginBottom: 8 }}>
            Sugestões — clique para incluir
          </Typography>
          <Box style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {SUGESTOES.map(sug => (
              <Chip
                key={sug.nome}
                size="small"
                label={sug.nome}
                variant="outlined"
                onClick={() => {
                  if (campos.some(c => c.nome === sug.nome)) return;
                  setCampos([...campos, { ...sug }]);
                }}
              />
            ))}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!campos.some(c => String(c.nome || "").trim() && String(c.valor || "").trim())}
          onClick={() => onSave({ campos: campos.filter(c => String(c.nome || "").trim()) })}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderSalvarNoContatoModal;
